export default __webpack_public_path__ + "images/0xae24f36ba2f8a109b913e55b78597b8ba7f7b8ff.png";